export const purple = {
    50: '#F2ECFD',
    100: '#E3D7FA',
    150: '#D3C2F6',
    200: '#C4ADF3',
    300: '#B497F0',
    400: '#A582ED',
    500: '#956DE9',
    600: '#8658E6',
    700: '#6D47BD',
    800: '#543694',
    850: '#3C256A',
    900: '#231441',
    950: '#0A0318'
};

//# sourceMappingURL=purple.js.map